import CityPageTemplate from "../city-template/CityPageTemplate";
import { sparksConfig } from "./data";

export default function SparksPage() {
  return <CityPageTemplate config={sparksConfig} />;
}